'use client'
import type { ReactNode } from 'react'
import { cx } from '../utils'

export function Sidebar({
  children,
  collapsed = false,
}: {
  children: ReactNode
  collapsed?: boolean
}) {
  return (
    <aside
      className={cx(
        'flex flex-col border-r border-line bg-surface',
        collapsed ? 'w-14' : 'min-w-[220px] max-w-[280px] flex-shrink-0',
      )}
    >
      {children}
    </aside>
  )
}

export function SidebarItem({
  icon,
  label,
  active,
  onClick,
}: {
  icon?: ReactNode
  label: string
  active?: boolean
  onClick?: () => void
}) {
  return (
    <button
      onClick={onClick}
      className={cx(
        'flex items-center gap-2.5 px-3 py-2 text-[15px] rounded-xs transition-colors duration-100',
        active
          ? 'bg-accent-soft text-ink font-medium'
          : 'text-ink-2 hover:bg-sunken hover:text-ink',
      )}
    >
      {icon}
      <span>{label}</span>
    </button>
  )
}
